/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CaseConditionDto } from './CaseConditionDto';
import {
    CaseConditionDtoFromJSON,
    CaseConditionDtoFromJSONTyped,
    CaseConditionDtoToJSON,
} from './CaseConditionDto';

/**
 * 
 * @export
 * @interface RuleSetAssignmentCriteriaUpdateDto
 */
export interface RuleSetAssignmentCriteriaUpdateDto {
    /**
     * 
     * @type {Array<CaseConditionDto>}
     * @memberof RuleSetAssignmentCriteriaUpdateDto
     */
    caseConditions: Array<CaseConditionDto>;
}

/**
 * Check if a given object implements the RuleSetAssignmentCriteriaUpdateDto interface.
 */
export function instanceOfRuleSetAssignmentCriteriaUpdateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "caseConditions" in value;

    return isInstance;
}

export function RuleSetAssignmentCriteriaUpdateDtoFromJSON(json: any): RuleSetAssignmentCriteriaUpdateDto {
    return RuleSetAssignmentCriteriaUpdateDtoFromJSONTyped(json, false);
}

export function RuleSetAssignmentCriteriaUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetAssignmentCriteriaUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseConditions': ((json['caseConditions'] as Array<any>).map(CaseConditionDtoFromJSON)),
    };
}

export function RuleSetAssignmentCriteriaUpdateDtoToJSON(value?: RuleSetAssignmentCriteriaUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseConditions': ((value.caseConditions as Array<any>).map(CaseConditionDtoToJSON)),
    };
}

